import i18n from "components/i18n/i18n";
import { FormRestrictions } from "./Restrictions";

export class LogicValidationUtils {
    public static getMessages(restrictions: FormRestrictions): { [key: string]: string } {
        const validationMessages = {};

        // tslint:disable-next-line: forin
        for (let property in restrictions) {
            let restriction = restrictions[property];
            if (restriction?.logicValidations != null && restriction.logicValidations.length > 0) {
                if (restriction.logicValidations[0].message?.key != null) {
                    validationMessages[property] = i18n.instance.t(restriction.logicValidations[0].message.key);
                } else {
                    validationMessages[property] = null;
                }
            }
        }

        return validationMessages;
    }
}
